import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Avatar, List } from 'antd';
import classnames from 'classnames';

import { getUserState } from '../../store/user/selector';
import { ChatProps } from '../../store/chat/types';

interface Messages {
  chat: ChatProps | undefined;
}

interface MessagesList {
  messages: string[];
  senderid: string;
}

export const Messages: React.FC<Messages> = ({ chat }) => {
  const { user } = useSelector(getUserState);
  const listRef = React.createRef<HTMLDivElement>();
  const message = chat?.message;

  const scrollToBottom = () => {
    if (message && listRef.current) {
      listRef.current?.scrollIntoView({ behavior: 'auto' });
    }
  };

  let messages: string[] = [];

  const reducedMessages: MessagesList[] = message?.reduce(
    (newValue: any, currValue, index: number) => {
      if (index > 0) {
        const prevIndex: number = index - 1;
        const prevChatItem = message[prevIndex].senderid;

        if (currValue.senderid === prevChatItem) {
          messages.push(currValue.message);
        } else {
          newValue.push({ senderid: prevChatItem, messages });
          messages = [];
          messages.push(currValue.message);
        }

        if (index + 1 === message.length || message.length === 1) {
          newValue.push({ senderid: currValue.senderid, messages });
          messages = [];
        }
      } else {
        messages.push(currValue.message);
      }
      if (message.length === 1) {
        newValue.push({ senderid: currValue.senderid, messages });
        messages = [];
      }
      if (newValue) return newValue;
    },
    []
  );

  useLayoutEffect(scrollToBottom, [message, user]);
  return (
    <div className="chat-messages-inner-container">
      <List
        dataSource={reducedMessages}
        renderItem={item => {
          const isSender = item.senderid === user.userid;
          const wrapperClass = classnames({
            'chat-message-wrapper': true,
            'sender-wrapper': isSender,
            'receiver-wrapper': !isSender,
          });
          const innerWrapper = classnames({
            'chat-message-inner-wrapper': isSender,
            'chat-message-inner-wrapper-receiver': !isSender,
          });
          const chatMessage = classnames({
            'chat-message': true,
            'receiver-message': !isSender,
          });
          return (
            <div className={wrapperClass}>
              <div className="chat-avatar">
                <Avatar src={isSender ? user.image : chat?.sender.image} />
              </div>
              <div className={innerWrapper}>
                {item.messages.map((itm, i) => {
                  return (
                    <div key={i}>
                      <div className={chatMessage}>{itm}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      />
      <div ref={listRef} />
    </div>
  );
};
